import { createNamedStub } from "../../demo/stubHelpers";
import { asDemoLocale } from "../../demo/demoLocale";
import { mockAttributes } from "../../demo/mockShopListings";

const combinationServices = {
  getAttributes: async (_academyId: string) => asDemoLocale({ Attributes: mockAttributes }),
  add: createNamedStub({}),
  update: createNamedStub({}),
  remove: createNamedStub({}),
};

export default combinationServices;
